const style = (theme) => {
  const output = {
    root: {
      minHeight: '100%',
      background: theme.colors[7],
      color: theme.colors[1],
      '& .relatedProducts__TitleWrapper': {
        extend: theme.wrapper,
        marginTop: 100,
      },
      '& .relatedProducts__separator': {
        marginLeft: '7vw',
        marginRight: '7vw',
      },
      '& .MainHero__mediaContainer': {
        background: theme.colors[7],
        '& img': {
          mixBlendMode: 'multiply',
        },
        '&::after': {
          background: theme.getRgba(theme.colors[2], 0.1),
        },
      },
    },
    wrapper: {
      extend: theme.wrapper,
      display: 'flex',
      paddingTop: 200,
    },
    hero: {
      color: theme.colors[1],
      '& .TextSlide__title': {
        fontSize: 'calc(52px + 6vw)',
      },
    },
    introText: {
      fontWeight: 300,
      fontSize: 50,
      lineHeight: 1.5,
    },
    parallaxText: {
      color: theme.colors[1],
    },
    grid: {
      display: 'flex',
      width: '100%',
    },
    gridColumn: {
      flexDirection: 'column',
    },
    gridHeading: {
      width: '45%',
      fontSize: 40,
      fontWeight: 300,
      textTransform: 'uppercase',
      lineHeight: 1,
    },
    gridContent: {
      flex: 1,
      fontSize: 20,
      lineHeight: 1.5,
      '& p': {
        marginBottom: 40,
      },
    },
    relatedImage: {
      display: 'block',
      overflow: 'hidden',
    },
    relatedItem: {
      '&:not(:last-child)': {
        marginBottom: 40,
      },
      '& > *:not(:last-child)': {
        marginBottom: 10,
      },
    },
    words: {
      paddingTop: 0,
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    hero: {
      '& .TextSlide__title': {
        fontSize: 'calc(30px + 4vw)',
      },
    },
    wrapper: {
      paddingTop: 100,
    },
    introText: {
      fontSize: 25,
      lineHeight: 1.2,
    },
    grid: {
      flexDirection: 'column',
      '& > *': {
        width: '100%',
        '&:not(:last-child)': {
          marginBottom: 40,
        },
      },
    },
  }

  return output
}

export default style
